import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { CheckIcon } from 'lucide-react';
export function CBAddOns() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-403">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-404">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-405">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-406">
            Be COURAGEOUS
          </span>

          <h2 className="text-[28px] lg:text-[44px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-407">
            ADD ONS TO MAXIMIZE YOUR GLOW
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-408"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-409">
          <AnimateOnScroll data-id="element-410">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-411">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-412">
                Exosomes
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-413">
                Enhance your Clear + Brilliant treatment with exosomes for even
                better results. When applied immediately after your laser
                treatment, exosomes amplify healing and skin regeneration by
                delivering growth factors and proteins directly to your skin
                cells.
              </p>
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll delay={150} data-id="element-414">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-415">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-416">
                Our Proprietary "Power Trio"
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body mb-6" data-id="element-417">
                Optimize your Clear + Brilliant treatment with Be CLINICAL's
                exclusive Power Trio blend. This proprietary mix includes stem
                cells, brightening agents, and peptides, all working together
                for glowing, beautiful results.
              </p>
              <ul className="space-y-4" data-id="element-418">
                <li className="flex items-start gap-3" data-id="element-419">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-420" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-421">
                    <strong className="text-white" data-id="element-422">Stem Cells</strong> –
                    Powerful growth factors that stimulate cells to behave
                    younger.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-423">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-424" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-425">
                    <strong className="text-white" data-id="element-426">Brightening Agents</strong> –
                    Glutathione and tranexamic acid for a luminous complexion.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-427">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-428" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-429">
                    <strong className="text-white" data-id="element-430">Peptides</strong> – Advanced
                    formula to improve skin cell function.
                  </span>
                </li>
              </ul>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}